import ChatMessageContent from '../ChatMessageContent';

import getMessage from './getMessage';

function getStakeholders(receiver, sender, userId) {
  const { company_name: companyName, datetime_created_at: dateTimeCreatedAt } = receiver;
  const { email, firstname, lastname, pict } = sender;
  return [
    {
      // demand receiver (aka company id)
      id: '8864c717-587d-472a-929a-8e5f298024da-0',
      username: `${companyName}`
    },
    {
      // demand sender
      id: userId,
      avatar: pict,
      name: firstname,
      username: `${firstname} ${lastname}`,
      email,
      lastActivity: dateTimeCreatedAt
    }
  ];
}

function getMessages(userId, oldValues, newValues, features, isPartner, isResource, currencyName) {
  const currency = currencyName.toLowerCase();
  const { title, body } = getMessage(oldValues, newValues, features, isPartner, isResource, currency);
  const {
    datetime_created_at: dateTimeCreatedAt,
    datetime_treated_at: dateTimeTreatedAt,
    file_path: filesPaths,
    response,
    status,
    text
  } = newValues;

  const baseMessage = {
    id: 'ae01158b-51d2-4b02-8122-33a04f015f4d',
    body: <ChatMessageContent paths={filesPaths} title={title} body={body} obs={text} />,
    contentType: 'text',
    createdAt: dateTimeCreatedAt,
    senderId: userId,
    urls: filesPaths?.split(',') || null
  };

  const responseStatusMap = {
    'En cours': 'Votre demande est en cours de traitement.',
    'En attente': 'Votre demande est en cours de traitement.',
    Acceptée: 'Votre demande a été acceptée.',
    Refusée: 'Votre demande a été refusée.',
    Partiellement: 'Votre demande est en cours de traitement.'
  };

  const responseMessage = {
    id: '31deb843-10e7-4d5d-816f-66b90239fcb8',
    body: response ? (
      <ChatMessageContent body={responseStatusMap[status] || ''} obs={response} response />
    ) : (
      responseStatusMap[status] || ''
    ),
    status,
    contentType: 'text',
    createdAt: dateTimeTreatedAt || dateTimeCreatedAt,
    senderId: '8864c717-587d-472a-929a-8e5f298024da-0'
  };

  return [baseMessage, responseMessage];
}

function getMoreData(userId, oldValues, newValues, features, isPartner, isResource, currencyName) {
  return {
    stakeholders: getStakeholders(newValues, oldValues, userId),
    messages: getMessages(userId, oldValues, newValues, features, isPartner, isResource, currencyName)
  };
}

export function transformData(userId, oldValues, newValues, features, isPartner, isResource, currencyName) {
  const formattedData = newValues
    .map((demand) => {
      const fields = demand?.fields ? JSON.parse(demand.fields) : {};
      let updatedDemand = {
        ...demand,
        fields,
        type: isPartner ? demand.type : demand.type_name
      };

      // 10 = Documents
      if (demand.type_id === 10) {
        updatedDemand = { ...updatedDemand, type_name: updatedDemand.type_name.slice(0, -1) };
      }

      return {
        ...updatedDemand,
        ...getMoreData(userId, oldValues, updatedDemand, features, isPartner, isResource, currencyName)
      };
    })
    .reduce(
      (acc, updatedDemand) => ({
        byId: { ...acc.byId, [updatedDemand.id]: updatedDemand },
        allIds: [...acc.allIds, updatedDemand.id]
      }),
      { byId: {}, allIds: [] }
    );

  return formattedData;
}
